import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { type CheckoutFunnelStats } from "@fitness-app/data-models/entities/CheckoutFunnelStats";

import { analyticsApi } from "~/store/initializeStore";

// Serwis trzyma wynik 5 minut — częstsze pytanie i tak dostałoby to samo.
const STALE_TIME_MS = 5 * 60 * 1000;

/** Analytics-service odsyła 503, gdy środowisko nie ma klucza do odczytu PostHoga. */
export const isCheckoutFunnelUnavailable = (error: unknown) =>
  axios.isAxiosError(error) && error.response?.status === 503;

export const useCheckoutFunnel = (range: { from: string; to: string }, enabled: boolean) =>
  useQuery({
    queryKey: ["checkoutFunnel", range.from, range.to],
    queryFn: async () => {
      const { data } = await analyticsApi.get<CheckoutFunnelStats>("/marketing/checkout-funnel", { params: range });
      return data;
    },
    enabled,
    keepPreviousData: true,
    staleTime: STALE_TIME_MS,
    retry: (failureCount, error) => !isCheckoutFunnelUnavailable(error) && failureCount < 2,
  });
